import React from 'react';
import styles from './cardStyles';

export const Column = ({ children, ...props }) => {
  if (children && typeof children === 'function') {
    return children({ colStyle: styles.column });
  }
  return (
    <div className={styles.column} {...props}>
      {children}
    </div>
  );
};

export const Row = ({ children, ...props }) => {
  if (children && typeof children === 'function') {
    return children({ rowStyle: styles.row });
  }
  return (
    <div className={styles.row} {...props}>
      {children}
    </div>
  );
};

const Card = ({ children, ...props }) => {
  if (children && typeof children === 'function') {
    // use only if you need to handle rendering logic in higher order component
    return children({ cardStyle: styles.card });
  }
  return (
    <div className={styles.card} {...props}>
      {children}
    </div>
  );
};

export default Card;
